// Work › Contacts at `/c/{slug}/work/contacts` (INC2-CONTACT; build order increment 2 C): the
// contact core's plain list. The work sidebar's footer links here (sidebars/work.tsx).
import { createRoute } from "@tanstack/react-router";
import { ContactsScreen } from "../features/contacts/contacts-screen";
import { useCompany } from "../features/use-feature";
import { workRoute } from "./c.$slug.work";

export const workContactsRoute = createRoute({
  getParentRoute: () => workRoute,
  path: "contacts",
  component: function WorkContacts() {
    const { api } = workContactsRoute.useRouteContext();
    return <ContactsScreen api={api} company={useCompany()} />;
  },
});
